import Vue from 'vue';

Vue.directive('xsmall', {
    bind: function (el, binding, vnode) {
        el.classList.add('v-btn--xsmall');
    }
});

Vue.directive('data-compact', {
    bind: function (el, binding, vnode) {
        el.classList.add('v-table--compact');
    }
});

Vue.directive('wst-accordion', {
    bind: function (el) {
        el.accordion_nodes = [];

        let check_accordion_node = (node) => {
            if (!!node
                && !!node.childNodes
                && !!node.childNodes[0]
                &&   node.childNodes[0].classList.contains('wst_accordion-title')
                && !!node.childNodes
                && !!node.childNodes[1]
                &&   node.childNodes[1].classList.contains('wst_accordion-content')){
                node.title_element = node.childNodes[0];
                node.content_element = node.childNodes[1];
                return true;
            }else return false;
        };
        el.clickBehaviour = (event) => {
            let node = (event.target || event.srcElement).parentNode;
            let brethren = node.parentNode.childNodes;

            for(let brother of brethren){
                if(  ! brother.isEqualNode(node)
                    && check_accordion_node(brother)){
                    brother.classList.remove('active');
                    brother.title_element.classList.remove('active');
                    brother.content_element.style.display = 'none';
                }
            }

            node.classList.add('active');
            node.title_element.classList.add('active');

            if (  !node.content_element.style.display
                || node.content_element.style.display ==='none')
                node.content_element.style.display = 'block';

        };

        for(let child of el.childNodes)
            if(check_accordion_node(child)){
                child.title_element.addEventListener('click', el.clickBehaviour);
                el.accordion_nodes.push(child);
            }

    },
    unbind: function(el){
        for(let node of el.accordion_nodes)
            node.title_element.removeEventListener('click', el.clickBehaviour)
    },
});
